import dayjs from 'dayjs';
import { marked } from 'marked';
import { JURISDICTION_LIST } from './constants';

export function groupBy<T>(
  array: T[],
  keyFn: (item: T) => string | number,
): Record<string, T[]> {
  return array.reduce(
    (result, item) => {
      const key = keyFn(item);
      (result[key] = result[key] || []).push(item);
      return result;
    },
    {} as Record<string, T[]>,
  );
}

export function unique(e: any, i: number, arr: any[]) {
  return arr.indexOf(e) === i;
}

export const pluralize = (count: number, noun: string, suffix: string = 's') =>
  `${count} ${noun}${count !== 1 ? suffix : ''}`;

const formatters: { [key: string]: Intl.NumberFormat } = {
  eur: new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }),
  usd: new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'USD' }),
};

export const formatPrice = (v: number, currency: string = '') => {
  const c = currency?.toLowerCase();
  if (c && c in formatters) {
    return formatters[c].format(v);
  }
  return formatters['usd'].format(v).replace(/\$\s*$/, c?.toUpperCase());
};

export const formatDate = (dateString: string) => {
  return dayjs(dateString).format('DD.MM.YYYY');
};

export const semanticJurisdiction = (jurisdiction: string) => {
  return (
    JURISDICTION_LIST.find((j) => j.code === jurisdiction)?.title ??
    jurisdiction
  );
};

const externalLinksExtension = {
  renderer: {
    link(token: { href: string; title?: string | null; text: string }) {
      const { href, title, text } = token;
      const titleAttr = title ? ` title="${title}"` : '';
      return `<a href="${href}"${titleAttr} target="_blank" rel="noopener noreferrer">${text}</a>`;
    },
  },
};

// Configure global marked instance
marked.use(externalLinksExtension);
